let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7Ny9U")).then(() => parcelRequire('7XkPG'));